import { render, staticRenderFns } from "./Visita.vue?vue&type=template&id=4d23bd16&"
import script from "./Visita.vue?vue&type=script&lang=js&"
export * from "./Visita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports